import axios from "axios";
import store from "../store/store";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_local,
  headers: {
    "Content-type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Origin": "*",
  }
});

const clientFile = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_local,
  headers: {
    'content-type': 'multipart/form-data',
    "Access-Control-Allow-Origin": "*",
  }
});

/**
 * Axios instance configured for making HTTP requests to the API.
 * 
 * This instance is created with a base URL taken from the environment variable
 * `REACT_APP_API_ENDPOINT_local` and includes default headers for JSON content type
 * and CORS settings.
 * 
 * @constant
 * @type {AxiosInstance}
 * 
 * @see {@link https://axios-http.com/docs/instance} for more information on Axios instances.
 */

const clientBlob = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_local,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE"
  }
});


// Interceptors for Bearer token (authentication)
client.interceptors.request.use(
  (request) => {
    const state = store.getState();
    const token = state.user?.accessToken;
    request.headers.Authorization = `Bearer ${token}`;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

clientFile.interceptors.request.use(
  (request) => {
    const state = store.getState();
    const token = state.user?.accessToken;
    request.headers.Authorization = `Bearer ${token}`;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

clientBlob.interceptors.request.use(
  (request) => {
    const state = store.getState();
    const token = state.user?.accessToken;
    request.headers.Authorization = `Bearer ${token}`;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptors for add author to request body
client.interceptors.request.use(
  (request) => {

    //get user _id from redux
    const state = store.getState();
    const userId = state.user?.user?._id;

    if (request.method === 'post' || request.method === 'put' || request.method === 'patch' || request.method === 'delete' ) {
      if (request.data) {
        request.data.requestedBy = userId;
      } else {
        request.data = { requestedBy: userId };
      }
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export { client, clientFile, clientBlob };